import { render, staticRenderFns } from "./Rules.vue?vue&type=template&id=018548cf&scoped=true&"
import script from "./Rules.vue?vue&type=script&lang=ts&"
export * from "./Rules.vue?vue&type=script&lang=ts&"
import style0 from "./Rules.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Rules.vue?vue&type=style&index=1&id=018548cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018548cf",
  null
  
)

export default component.exports